export const DROPDOWN_CLASS_NAME = 'ds-dropdown-list'
